/**
 * Security utilities for PIN hashing and validation
 */

/**
 * Simple hash function for PIN
 * In production, use a proper hashing library like bcrypt or crypto-js
 */
export function hashPin(pin: string): string {
  // For now, using a simple hash
  // TODO: Replace with proper hashing (bcrypt, scrypt, etc.)
  let hash = 0;
  const salt = 'fish-daily-2025'; // Add salt
  const combined = pin + salt;
  
  for (let i = 0; i < combined.length; i++) {
    const char = combined.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  
  return hash.toString(16);
}

/**
 * Validate PIN format
 */
export function isValidPin(pin: string): boolean {
  // PIN should be 4 digits
  return /^\d{4}$/.test(pin);
}

/**
 * Generate random PIN (for testing)
 */
export function generateRandomPin(): string {
  return Math.floor(1000 + Math.random() * 9000).toString();
}
